import { Template } from "../components/pages/services/template";

export function TemplatePage(props){

    return(
        <>
            <Template data={props.data}/>
        </>
    );
}